<div class="main-loading">
  <div class="all-center">
    <div class="ic1-logo"></div>
    <h4>{{ mainTextCustom == null ? mainText : mainTextCustom }}</h4>
    <!--button class="ic1-login-button" id="prelogin-button-login" (click)="goToLogin()">{{ 'PROCESS-COMPLETED.LOGIN.BUTTON' | translate }}</button-->
  </div>
</div>